import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';

// Declare module augmentation for IconButtonPropsColorOverrides
declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    neutral: true;
    alert: true;
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IconButtonProps extends MuiIconButtonProps {}

export function IconButton<C extends React.ElementType = 'button'>(
  props: MuiIconButtonProps<C, { component?: C } & IconButtonProps>
) {
  const { sx, ...otherProps } = props;
  return (
    <MuiIconButton
      sx={[
        {
          borderRadius: '50svh',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...otherProps}
    />
  );
}
